module.exports = __webpack_public_path__ + "static/img/SFU教室_2.33ade4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU教室_2.png
// module id = lDsS
// module chunks = 0